module.exports = __webpack_public_path__ + "img/screenshot.8f904d0d.png";